<template>
    <b-card :title="$translate('filters')" class="query-filter filter-form" body-class="p-0 mt-3">
        <div>
            <b-row>
              <input type="hidden" v-model="filtersModel.customer_id" >
                <b-col cols="12" md="6" class="mt-3">
                    <label for="input-activity" class="mb-3"><strong>{{ $translate('date_attached_from')
                    }}</strong></label>
                    <b-input id="input-start-date" type="date" :placeholder="$translate('date_attached_from')" v-model="filtersModel.start_date"></b-input>
                </b-col>
                <b-col cols="12" md="6" class="mt-3">
                    <label for="input-activity" class="mb-3"><strong>{{ $translate('date_attached_to')
                    }}</strong></label>
                    <b-input id="input-start-date" type="date" :placeholder="$translate('date_attached_to')" v-model="filtersModel.end_date"></b-input>
                </b-col>
                <b-col cols="12" md="6" class="mt-3">
                  <label class="mb-3"><strong>{{ $translate('attached_by') }} </strong></label>
                    <b-form-select
                      id="input-document_type"
                      v-model="filtersModel.attached_by"
                      :options="users"
                      value-field="id"
                                text-field="name"
                    ></b-form-select> 
                  </b-col>
                  <b-col md="6" cols="12" class="mt-3 mt-md-3 dd">
                    <label class="mb-2"><strong> {{ $translate('attached_to') }}</strong></label>
                  
                    <multiselect id="input-status" :placeholder="$translate('select_attached_to')" 
                    v-model="filtersModel.attached_to" 
                    :options="attached_toArray" 
                    :searchable="true"
                   
                    :multiple="true" 
                    :preserve-search="true"
                    :selectLabel="selectLabel" 
                   
                    label="name" track-by="id" :close-on-select="true">
                       
                    </multiselect>
                </b-col>
                <b-col md="4" cols="12" class="mt-3 text-start">
                    <label for="input-outstanding_balance" class="mb-3"><strong>{{$translate('keywords')}}</strong></label>
                    
                    <b-row>
                        <b-col cols="4">
                            <select class="form-control" v-model="filtersModel.search" value-field="id"
                                text-field="name" block>
                                <option v-for="x in quantities" :key="'customselect:--' + x.id" :value="x.id">
                                    {{ x.name }}
                                </option>
                            </select>
                        </b-col>
                        
                        <b-col cols="8">
                            <multiselect id="input-status"
                            :placeholder="$translate('type_keywords')" 
                            v-model="filtersModel.keywords" 
                            :options="keywords" 
                            :searchable="true"
                            :multiple="true" 
                            :preserve-search="true"
                            :selectLabel="selectLabel" 
                            label="name" 
                            track-by="id" 
                            :close-on-select="true"
                            taggable
                            @tag="addCustomOption">
                            </multiselect>
               
                        </b-col>
                    </b-row>
                </b-col>
                
                
            </b-row>
        </div>
    </b-card>
</template>

<script>
// import CustomerTypeAhead from "@/components/CustomerTypeAhead.vue";
import Multiselect from 'vue-multiselect'
export default {
    name: 'filters',
    components:{
      Multiselect
    },
    data(){
        return {

            quantities: [
                { id: 'and', name: 'AND' },
                { id: 'or', name: 'OR' },
                
            ],
            attached_toArray : [],
            keywords : [],
            // filtersModel: {
            //     start_date : null,
            //     end_date : null,
            //     attached_to: null,
            //     attached_by : null,
            //     keywords :null,
            //     search: null,
            // },
        }
    },  
    props: ['value'],
    // components:{CustomerTypeAhead },
    mounted() {
      if(this.status && this.status.length > 0){

      this.attached_toArray = this.status
      }

      const customerId = this.$store.state.customers.item?.id;
        if (customerId != null) {
            this.filtersModel.customer_id = customerId;
        }
      
    },
    computed: {
      status() {
            return [
                { id: 'Customer', name: 'Customer' },
                { id: 'Activity', name: 'Activity' },
                { id: 'Payment', name: 'Payment' },
                { id: 'Asset', name: 'Asset' },
                { id: 'WorkFlow', name: 'WorkFlow' },
             
            ]
        },
        filtersModel: {
            // getter
            get() {
                return this.value
            },
            // setter
            set(val) {
                this.$emit('input', val)
            },
        },

        paymentTransactionStatus() {
            return {
                pending: "Pending",
                processed: "Processed",
                cancelled: "Cancelled"
            }
        },

        transaction_type() {
            return {
                incoming: 'Incoming',
                outgoing: 'Outgoing',
            };
        },
        users(){
            return this.$store.state.user_roster.drivers.map(user => {
            return {
                ...user,
                name: `${user.first_name} ${user.last_name}`
            };
          });
        },
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
 
    },

    watch: {},

    methods: {
        addCustomOption(newOption) {
            const newOptionObject = { id: newOption, name: newOption };
            
            // Add the new option to the attached_toArray
            this.keywords.push(newOptionObject);

            // Ensure attached_to is an array and not undefined
            const attachedToArray = Array.isArray(this.filtersModel.keywords)
                ? [...this.filtersModel.keywords]
                : [];

            // Add the new option to the attached_to array
            attachedToArray.push(newOptionObject);

            // Update the filtersModel with the new attached_to array
            const updatedFiltersModel = {
                ...this.filtersModel,
                keywords: attachedToArray
            };

            // Update the filtersModel
            this.filtersModel = updatedFiltersModel;
        },
        // other methods
       
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags-wrap {
    display: inline-block;
    height: auto;
}
</style>